export const CALCULATION_URL='/calculation';